import { render, staticRenderFns } from "./AtaListagemBotoesAcoes.vue?vue&type=template&id=36fa5d64&scoped=true"
import script from "./AtaListagemBotoesAcoes.vue?vue&type=script&lang=js"
export * from "./AtaListagemBotoesAcoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fa5d64",
  null
  
)

export default component.exports